import React from "react"
import { formatCurrencyString } from "../../utils/format"

import styled from "styled-components"
import { devices } from "../config/breakpoints"

import { Currency } from "../../checkout/types/checkoutTypes"
import { Product } from "../../checkout/product"
import { Box } from "@mui/system"
import { Link } from "gatsby"
import { queueOrSendGoogleEvent } from "../../utils/pixel"

export const Wrapper = styled.div`
  display: flex;
  vertical-align: center;
  justify-content: flex-end;
  margin: 1rem 0;
  @media ${devices.mobilePhone} {
    margin: 0;
  }
`

export const Card = styled.div<{ small: boolean }>`
  padding: ${({ small }) => (small ? "0.6rem 0" : "1rem 0")};
  padding-top: 0;
  background-color: var(--color-white);
  display: flex;
  vertical-align: center;
  text-align: left;
  justify-content: start;
`

export const Row = styled.div<{ small: boolean; forceNewLine?: boolean }>`
  display: ${({ forceNewLine }) => (forceNewLine ? `block` : "flex")};
  vertical-align: center;
  text-align: left;
  align-items: center;
  justify-content: start;
  flex-wrap: wrap;
  @media ${({ small }) =>
      small ? `(max-width: 1200px)` : devices.mobilePhone} {
    display: block;
  }
`

const Dividor = styled.div<{ small: boolean; forceNewLine?: boolean }>`
  width: 1px;
  height: 60px;
  border-left: 1px solid #a7a9ac;
  margin: ${({ small }) => (small ? "0 1rem" : "0 2.5rem")};
  @media ${devices.mobile} {
    margin: 0 2em;
  }
  position: relative;
  span {
    position: absolute;
    left: -12px;
    top: 33%;
    background-color: #ffffff;
    color: #000000;
  }
  @media ${({ small }) =>
      small ? `(max-width: 1200px)` : devices.mobilePhone} {
    height: 1px;
    width: 150px;
    border-top: 1px solid rgb(167, 169, 172);
    border-left: 0;
    margin: 1rem 0;
    span {
      top: -12px;
      left: 37%;
      width: 36px;
      display: block;
      text-align: center;
    }
  }
  ${({ forceNewLine }) =>
    !forceNewLine
      ? ""
      : `
       height: 1px;
    width: 150px;
    border-top: 1px solid rgb(167, 169, 172);
    border-left: 0;
    margin: 1rem 0;
    span {
      top: -12px;
      left: 37%;
      width: 36px;
      display: block;
      text-align: center;
    }
      `};
`

const StyledPrice = styled.div<{ small: boolean; color?: string }>`
  font-family: var(--font-family-header);
  font-weight: 200;
  font-size: 3rem;
  letter-spacing: 0px;
  line-height: 2.3rem;

  color: ${({ color }) => color || "var(--color-teal)"};
  font-size: ${({ small }) => (small ? "1.5rem" : "1.8rem")};
  margin: 0;
  sup {
    text-transform: uppercase;
    vertical-align: super;
    font-size: ${({ small }) => (small ? "0.9rem" : "1.1rem")};
    color: var(--color-black);
    font-weight: 400;
    margin-left: 0.4rem;
  }
  @media ${devices.mobile} {
    line-height: 2rem;
    font-size: ${({ small }) => (small ? "1.4" : "1.5rem")};
    sup {
      font-size: ${({ small }) => (small ? "0.8rem" : "0.9rem")};
    }
  }
`

export type RelatedPrice = {
  product: Product
  currency: Currency
}
export const ProductRelatedPrice = ({
  relatedPrice,
  small,
  forceNewLine,
}: {
  relatedPrice: RelatedPrice
  small: boolean
  forceNewLine?: boolean
}) => {
  if (!relatedPrice.product.relatedPriceTxt) {
    return null
  }

  return (
    <>
      {forceNewLine && <Box sx={{ flexBasis: "100%", height: 0 }}></Box>}

      <Row small={small} forceNewLine={forceNewLine}>
        <Dividor small={small} forceNewLine={forceNewLine}>
          <span>OR</span>
        </Dividor>
        <Box>
          <StyledPrice small={small} id="product-related-price">
            <div>
              {formatCurrencyString({
                value:
                  relatedPrice.product.getPriceAmt(
                    relatedPrice.currency,
                    false
                  ) ?? 0,
                currency: relatedPrice.currency.toUpperCase(),
              })}

              <sup>{relatedPrice.currency.toUpperCase()}</sup>
            </div>
          </StyledPrice>
          <Box
            sx={{
              backgroundColor: "rgba(29, 153, 184, 0.2)",
              padding: "0.5rem",
              borderRadius: "0.5rem",
              a: {
                textDecoration: "underline",
                color: "#000000",
                "&:hover": {
                  color: "var(--color-purple)",
                },
              },
            }}
          >
            <Link
              to={`${relatedPrice.product.cleanSlug()}`}
              activeClassName="active"
              id={relatedPrice.product.id + "_related"}
              title={relatedPrice.product.relatedPriceTxt}
              onClick={d => {
                queueOrSendGoogleEvent("related_product_click", {
                  product: relatedPrice.product.id,
                  text: relatedPrice.product.relatedPriceTxt,
                })
              }}
            >
              &gt; {relatedPrice.product.relatedPriceTxt}
            </Link>
          </Box>
        </Box>
      </Row>
    </>
  )
}
